import React from 'react';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>YourBrand</h3>
          <p>Delivering excellence and innovation for your business.</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact</h4>
          <p>Email: info@yourbrand.com</p>
          <p>Phone: +1 (234) 567-890</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {year} YourBrand. All rights reserved.</p>
      </div>
    </footer>
  );
}
